module.exports = __webpack_public_path__ + "static/media/AirIndiaThumbnail.7f560342.JPG";